import { Flex } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";


import TextField from "shared/components/form/TextField";

const Form = () => {
  const { t } = useTranslation();
  return (
    <Flex gap="20px" direction="column" w="100%">
      <TextField
        name="newUrl"
        label="URL"
        required
      />
      <TextField
        name="newText"
        label="Text"
        required
        textarea
        rows={10}
      />
    </Flex>
  );
};

export default Form;
